import dayjs from "dayjs";
import "dayjs/locale/pl";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const getCalendarTime = (timestamp: string) => dayjs().locale("pl").to(dayjs(timestamp));
